export const Config = {
    scheme: 'http',
    host: 'localhost:3000'
}